export default "__VITE_ASSET__CvqnUbhT__"